import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getUsersActive,
    getShipmentsGenerated,
    getShipmentsSales,
    getShipmentsProfit,
    getShipmentsMargin,
    getShipmentsAverageTicket,
    getShipmentsAverageCost,
    getShipmentsAverageDeliveryDays,
    getPickupsScheduled,
    getShipmentsTotal,
    getShipmentsCanceled,
    getShipmentsFinalprice,
    getShipmentsShipmentcost,
    getShipmentsProvidersTop,
    getShipmentsClientsTop,
    getShipmentsClientsProfit,
    getCreditsLatest,
    getCreditsUsersTop,
    getCharges,
    getChargesPending,
    getChargesUsersTop,
    getChargesRefundsUsersTop,
    getEventsActivity,
}

function getUsersActive(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/users/active`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsGenerated(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/generated`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsSales(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/sales`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsProfit(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/profit`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsMargin(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/margin`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsAverageTicket(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/average-ticket`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsAverageCost(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/average-cost`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsAverageDeliveryDays(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/average-delivery-days`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getPickupsScheduled(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/pickups/scheduled`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsTotal(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/total`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsCanceled(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/canceled`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsFinalprice(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/finalprice`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsShipmentcost(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/shipmentcost`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsProvidersTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/providers/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsClientsTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/clients/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsClientsProfit(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/shipments/clients/profit`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getCreditsLatest(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/credits/latest`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getCreditsUsersTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/credits/users/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getCharges(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/charges`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesPending(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/charges/pending`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesUsersTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/charges/users/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesRefundsUsersTop(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/charges/refunds/users/top`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getEventsActivity(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/statistics/events/activity`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}
